import { roundValue } from "lib/number";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { ValueGetterParams } from "ag-grid-community";
import { loopGridNode, referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenPlanRow } from "./plan-rows";
import memoizeOne from "memoize-one";

/**
 * Get aggregrated total plan rows of the entire column. Loop through all row nodes and sum their values.
 */
const getColumnTotalPlanRow = memoizeOne(
    (options: MergedColumnFormulaOptions, valueGetterParams: ValueGetterParams) => {
        let totalPlanRows = 0;
        loopGridNode(valueGetterParams.api, (childNode) => {
            const childGetterParams = {
                ...valueGetterParams,
                node: childNode,
                data: childNode.data,
            };
            const planRows = referenceMetricValueOrCompute(
                () => getChildrenPlanRow(options, childGetterParams),
                childGetterParams,
                MetricsKind.PLAN_ROWS
            );
            totalPlanRows += planRows;
        });

        return totalPlanRows;
    },
    (newArgs, oldArgs) =>
        newArgs[1].colDef.colId === oldArgs[1].colDef.colId && newArgs[1].node.id === oldArgs[1].node.id
);

export const BREADTH_PERCENTAGE_PLAN = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const planRowValue = referenceMetricValueOrCompute(
        () => getChildrenPlanRow(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.PLAN_ROWS
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!planRowValue) {
        return 0;
    }

    const totalPlanRowValue = getColumnTotalPlanRow(options, gridGetterParams);

    return totalPlanRowValue > 0 ? roundValue((planRowValue / totalPlanRowValue) * 100, options.decimal) : 0;
};
